import { Outlet } from "react-router-dom";
import BuyerAuthHeader from "@/components/buyer/auth/BuyerAuthHeader";
import BuyerAuthFooter from "@/components/buyer/auth/BuyerAuthFooter";

const BuyerAuthLayout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-[#080c14] text-white">
      <BuyerAuthHeader />
      
      <main className="flex-grow flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>
      
      <BuyerAuthFooter />
    </div>
  );
};

export default BuyerAuthLayout;
